import React from 'react'
import { observer } from 'mobx-react-lite'

import ToggleButton from '@mui/material/ToggleButton'
import { alpha, useTheme } from '@mui/material/styles'

import { Flag as FlagOutlinedIcon } from '@mxenabled/mx-icons'

import type { Transaction } from '../../../../core'

import {
  ANALYTICS_EVENTS,
  useEvent,
  useGlobalCopyStore,
  useTransactionStore,
} from '../../../../common'

interface FlagTransactionProps {
  transaction: Transaction
}

const FlagTransaction: React.FC<FlagTransactionProps> = ({ transaction }) => {
  const { updateTransaction } = useTransactionStore()
  const { transactions: copy } = useGlobalCopyStore()
  const { onEvent } = useEvent()

  const theme = useTheme()
  const isDarkMode = theme.palette.mode === 'dark'

  const handleFlagTransaction = async () => {
    onEvent(ANALYTICS_EVENTS.TRANSACTION_DETAILS_CLICK_FLAG, { transaction_guid: transaction.guid })
    await updateTransaction({ ...transaction, is_flagged: !transaction.is_flagged })
  }

  return (
    <div className="mx-txn-transaction-flag">
      <ToggleButton
        aria-label={copy.flag_btn_aria}
        aria-pressed={transaction.is_flagged}
        color={isDarkMode ? 'primary' : 'warning'}
        onClick={handleFlagTransaction}
        selected={transaction.is_flagged}
        sx={{
          borderRadius: 6,
          color: isDarkMode ? 'common.white' : 'secondary.main',
          '&.Mui-selected': {
            color: isDarkMode ? 'primary.main' : 'common.white',
            backgroundColor: isDarkMode ? alpha(theme.palette.primary.main, 0.25) : 'warning.dark',
            ':hover': {
              color: isDarkMode ? 'primary.main' : 'common.white',
              backgroundColor: isDarkMode ? alpha(theme.palette.primary.main, 0.2) : 'warning.main',
            },
          },
          ':hover': {
            color: isDarkMode ? 'common.white' : 'warning.contrastText',
            backgroundColor: isDarkMode ? alpha(theme.palette.primary.main, 0.2) : 'warning.light',
          },
        }}
        value="flagged"
      >
        <FlagOutlinedIcon color="inherit" />
      </ToggleButton>
    </div>
  )
}
export default observer(FlagTransaction)
